import jquery from 'jquery';
import EFOcats_event_core from './efocats_event_core.js';

/**
 * 送信ボタンクリックイベント
 */
export default class EFOcats_event_submit extends EFOcats_event_core {
  /**
   * イベントための事前の仕込み
   */
  init() {
    // 処理なし
  }

  /**
   * イベント本体をセット
   */
  event() {
    this.$('body').on('click', '.submit-btn', event => {
      const element = event.currentTarget;

      if (!jquery(element).parents('section').hasClass('go-flag') && !jquery(element).parents('section').hasClass('checked')) {
        jquery(element)
          .parents('section')
          .find('input,textarea,select')
          .each((index, elem) => {
            // 既にエラーが表示されている場合はスキップ
            if (jquery(elem).parents('.check-flag').attr('data-error-text') && jquery(elem).parents('.check-flag').attr('data-error-text') !== '') {
              return;
            }

            efocats.validations.check_error(jquery(elem));
          });
      }
      // checkedを外す
      jquery(element).parents('section').removeClass('checked');
    });

    this.$('body').on('click', '.go-flag .submit-btn', event => {
      efocats.submit.data_submit(jquery(event.currentTarget));
    });
  }
}
